module.exports = __webpack_public_path__ + "img/699a0fd.png";